import moment from "moment";
import React, { Component, Fragment } from "react";
import { Bounce, toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import * as PicaCSVzService from "../../../services/clients/api_pica_cs_vz";
import OnStation from "../../../Stations/OnStations";
import StationStatistics from "../../../Stations/Statistics";
import { checkForAuthenticationError } from "../../../utils/functions";
import PicaCSVzTable from "../components/PicaC&SVzTable";


const DEFAULT_START_DATE = null; // LAST DAY

class PicaCSVzTab1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: {},
      loadingStatistics: true,
      onStation: [],
      loadingOnStation: true,
      showOnStation: false,
      graphData: props.data,
      startDate: new Date().getTime(),
      endDate: new Date().getTime(),
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  async componentDidMount() {
    this._isMounted = true;

    // Get On Station:
    await this.getOnStation();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async getStats(startDate, endDate) {
    this.setState({ statistics: {}, loadingStatistics: true }, async () => {
      let jsonResponse = null;
      try {
        const promise = PicaCSVzService.getStats(startDate, endDate);
        jsonResponse = await promise;
      } catch (error) {
        toast(error.toString(), {
          transition: Bounce,
          closeButton: true,
          autoClose: 2000,
          position: "top-right",
          type: "error",
        });
      }

      if (jsonResponse != null && !checkForAuthenticationError(jsonResponse)) {
        const { data } = jsonResponse;

        if (data !== undefined && this._isMounted) {
          this.setState({ statistics: data, loadingStatistics: false });
        }
      } else {
        this.setState({ statistics: {}, loadingStatistics: false });
      }
    });
  }

  async getOnStation() {
    this.setState({ onStation: [], loadingOnStation: true });

    const promise = PicaCSVzService.getOnStation();
    const jsonResponse = await promise;
    const { data } = jsonResponse;

    if (!checkForAuthenticationError(jsonResponse)) {
      if (data !== undefined && this._isMounted) {
        this.setState({ onStation: data, loadingOnStation: false });
      }
    } else {
      this.setState({ loadingOnStation: false });
    }
  }

  handleShowOnStation = () => {
    this.setState({ showOnStation: true, key: Math.random() });
  };

  handleHideOnStation = () => {
    this.setState({ showOnStation: false, key: Math.random() });
  };

  handleSearchStats(startDate, endDate) {
    this.getStats(startDate, endDate);
  }
  /*********************************** HANDLERS ***********************************/
  handleChangeDate = (selectedOption) => {
    console.log(selectedOption);
    if (selectedOption !== undefined && selectedOption.value !== undefined) {
      // Get Stats:
      const endDate = new Date().getTime();
      var startDate;

      var { value } = selectedOption;
      value = parseInt(value, 10);

      switch (value) {
        case 1:
          // Today:
          startDate = null;
          break;
        case 2:
          // Today:
          startDate = moment();
          break;
        case 3:
          // Last Week:
          startDate = moment().subtract(1, "week");
          break;
        case 4:
          // Last 30 Days:
          startDate = moment().subtract(30, "day");
          break;
        case 5:
          // Last 3 Months:
          startDate = moment().subtract(3, "month");
          break;
        case 6:
          // Last Year:
          startDate = moment().subtract(1, "year");
          break;
        default:
          startDate = DEFAULT_START_DATE;
      }

      this.setState({ loadingStatistics: true }, () => {
        this.getStats(startDate, endDate);
      });
    }
  };

  render() {
    const {
      statistics,
      loadingStatistics,
      onStation,
      loadingOnStation,
      graphData,
      startDate,
      endDate,
    } = this.state;

    return (
      <Fragment key={this.state.key}>
        <Row>
          <Col md="2" style={{ paddingRight: 0 }}>
            <OnStation
              blocking={loadingOnStation}
              loaderType="line-scale-pulse-out"
              data={onStation}
              icon="metismenu-icon pe-7s-pendrive text-white"
              title="XFPs"
              showOnStation={this.handleShowOnStation}
            />
          </Col>
          <Col md="10">
            <StationStatistics
              blocking={loadingStatistics}
              loaderType="line-scale-pulse-out"
              onChangeDate={this.handleChangeDate}
              statistics={statistics}
              elemSize={3}
              show={true}
              icon="metismenu-icon pe-7s-pendrive text-white"
              title="XFPs"
            />
          </Col>
        </Row>

        <PicaCSVzTable
          loaderType="line-scale-pulse-out"
          showOnStation={this.state.showOnStation}
          onHideStation={this.handleHideOnStation}
          graphData={graphData}
          startDate={startDate}
          endDate={endDate}
          handleSearchStats={this.handleSearchStats.bind(this)}
        />
      </Fragment>
    );
  }
}

export default PicaCSVzTab1;



// WEBPACK FOOTER //
// ./src/Clients/PicaC&SVz/tabs/PicaC&SVzTab1.js